import React from 'react'
import './Loading.css'

const Loading = () => {
  return (
    <div className='loadingContainer'>
      <div className="outerBox">
        <div className="innerBox"></div>
      </div>
    </div>
  )
}

export default Loading
